import { render, staticRenderFns } from "./CafeSubMenuItem.vue?vue&type=template&id=31c6389c&"
import script from "./CafeSubMenuItem.vue?vue&type=script&lang=js&"
export * from "./CafeSubMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('31c6389c', component.options)
    } else {
      api.reload('31c6389c', component.options)
    }
    module.hot.accept("./CafeSubMenuItem.vue?vue&type=template&id=31c6389c&", function () {
      api.rerender('31c6389c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/common/CafeSubMenuItem.vue"
export default component.exports